import { useState } from 'react';
import styles from 'styles/modules/popUps/Uploader.module.scss';
import UploaderDragAndDrop from './UploaderDragAndDrop';

export default function UploaderSelect({ onChange }) {
    const [file, setFile] = useState(null);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setFile(e.target.files[0]);
            onChange(e.target.files[0]);
        }
    };

    const handleDrop = (files) => {
        if (files.length > 0) {
            setFile(files[0]);
            onChange(files[0]);
        }
    };

    return (
        <div>
            <UploaderDragAndDrop
                handleDrop={handleDrop}
                className={styles.dropArea}
            >
                <div className={styles.dropAreaBody}>
                    <input
                        type="file"
                        onChange={handleChange}
                        className={styles.dropInput}
                    />
                    <div
                        className={[styles.title, styles.dropAreaTitle].join(
                            ' '
                        )}
                    >
                        Drag your file here
                    </div>

                    <div className={styles.dropAreaPlus}>Add file</div>

                    <div className={styles.dropAreaSubtitle}>
                        or select a file
                    </div>
                </div>
            </UploaderDragAndDrop>
        </div>
    );
}
